/* MEDIA PLAYER LIST COMPONENT ************************************************/

import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Utilities */
import { filterAndSort } from 'util/list'

/* Components */
import MediaPlayerItem from 'component/media-player/item'
import BulkEdit from 'component/media-player/bulk-edit'

/* Widgets */
import SearchInput from 'widget/search-input'
import SortToolbar from 'widget/sort-toolbar'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Actions */
import {
  fetchItems,
  fetchStatus,
  saveFilter,
  fetchFilter,
  fetchSort,
  saveSort,
  nextPage
} from 'react-redux/actions/media-player'
import {showModal, hideModal} from 'react-redux/actions/modal'

/* Selectors */

import selector from './selector'

/* Styles */
import './list.css'

class MediaPlayerList extends Component {

  constructor(props) {
    super(props)
    this.state = { showBackToTop: false }
  }

  componentDidMount() {
    const { fetchFilter, fetchSort, filter, sort } = this.props
    if (!filter.initialized) fetchFilter()
    if (!sort.initialized) fetchSort()
    window.addEventListener("resize", this.loadMore.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.loadMore.bind(this));
  }

  componentWillReceiveProps(nextProps) { }

  componentDidUpdate() {
    const {
      fetchItems,
      pagination,
      maxResults,
      fetchingList,
      filter,
      globalFilter,
      query,
      sort
    } = this.props
    const initialized = filter.initialized
      && globalFilter.initialized
      && sort.initialized
    const filterString = _.compact(
      [filter.expression, globalFilter.expression]
    ).join(" ")
    const resultChange = filterString !== query.filter
      || sort.field !== query.sort_by_field
      || sort.reverse[sort.field] != query.reverse_order
    const shouldLoad = resultChange || pagination.page !== query.page

    if (initialized && !fetchingList) {
      if (shouldLoad) {
        fetchItems(
          {
            filter: filterString,
            page: resultChange ? 0: pagination.page
          }
        )
      } else {
        this.loadMore()
      }
    }
  }

  loadMore() {
    const { pagination, nextPage } = this.props
    if (
      !pagination.reachedEnd
      && (
        this.listBody
        && this.listElem
        && (this.listBody.clientHeight + 200) >= this.listElem.scrollHeight - this.listBody.scrollTop
      )
    ) {
      nextPage()
    }
  }

  onScroll(e) {
    if (!this.state.showBackToTop && this.listElem.scrollTop > 0)
      this.setState({ showBackToTop: true })
    else if (this.state.showBackToTop && this.listElem.scrollTop == 0)
      this.setState({ showBackToTop: false })
    this.loadMore()
  }

  filterMediaPlayer(value) {
    const { saveFilter } = this.props
    saveFilter(value)
  }

  resetFilter(e) {
    const { saveFilter } = this.props
    saveFilter("")
  }

  onSortSelect(field, reverse) {
    const { sort, saveSort } = this.props
    let r = Object.assign({}, sort.reverse)
    r[field] = reverse
    saveSort({ field, reverse: r })
  }

  onBackToTopClick(e) {
    this.listElem.scrollTop = 0
  }

  renderPlaceholder() {
    const { filter, list, t } = this.props
    if (list.length) return null
    let text
    if (filter.expression === "") text = t("mediaplayer:list.empty.noItems")
    else text = t("mediaplayer:list.empty.noResults")
    return <div className="placeholder">{ text }</div>
  }

  /**
  * Show a Placeholder if no assets are available
  */
  renderBulkSectionHeadline() {
    const { filter, globalFilter, t } = this.props
    const filterString = _.compact(
      [filter.expression, globalFilter.expression]
    ).join(" ")
    if (!filterString) return null
    return (
      <li key="bulk-section-headline" className="section-headline">
        <span className="wrapper">{ t("mediaplayer:list.bulk.sectionHeadline") }</span>
      </li>
    )
  }

  /**
  * Show a Placeholder if no assets are available
  */
  renderBulkEdit() {
    const { filter, globalFilter, bulkSync } = this.props
    const filterString = _.compact(
      [filter.expression, globalFilter.expression]
    ).join(" ")
    if (bulkSync.pending == 0 && !filterString) return null
    return <BulkEdit></BulkEdit>
  }

  renderMediaPlayerItems() {
    const { list } = this.props
    return (
      _.map(list, item => {
        return <MediaPlayerItem key={ item } uid={ item }/>
      })
    )
  }

  renderSortToolbar() {
    const {
      sort,
      t
    } = this.props
    const items = [
      {
        name: "name",
        reverse: sort.reverse.name,
        label: t("mediaplayer:list.sort.name"),
        selected: sort.field === "name"
      },
      {
         name: "description",
         reverse: sort.reverse.description,
         label: t("mediaplayer:list.sort.description"),
         selected: sort.field === "description"
       },
    ]
    return (
      <SortToolbar
        items={ items }
        onSelect={ this.onSortSelect.bind(this) }
      ></SortToolbar>
    )
  }

  renderBackToTop() {
    if (this.state.showBackToTop) return (
      <div className="back-to-top">
        <Icon
          icon={ ICON.SCROLL_TO_TOP }
          scheme={ ICON_SCHEME.ACTION }
          size={ 32 } circle={ true }
          interactive={ true }
          onClick={ this.onBackToTopClick.bind(this) }
        />
      </div>
    )
    return null
  }

  renderNextPage() {
    const { pagination, nextPage, t } = this.props
    if (!pagination.reachedEnd) {
      return (
        <li key="pagination-helper" className="pagination-helper" onClick={ nextPage.bind(this) }>
          <div className="spinner">
            <Icon
              icon={ ICON.LOADING_SYNC }
              scheme={ ICON_SCHEME.ACTION }
              size={ 32 } circle={ true }
              interactive={ true }
              spin={ true }
              interactive={ true }
            />
          </div>
          <div className="caption">
            { t("mediaplayer:list.pagination.loading") }
          </div>
        </li>
      )
    }
    return null
  }

  render() {
    const { t, filter } = this.props
    return (
      <div className="media-player-list component column-list">
        <div className="header">
          <h2>{ t("mediaplayer:list.headline") }</h2>
        </div>
        <div className="filter-input-wrapper">
          <SearchInput
            className="filter-input"
            type="text"
            onChange={ this.filterMediaPlayer.bind(this) }
            onReset={ this.resetFilter.bind(this) }
            value={ filter.expression || "" }
            placeholder={ t("mediaplayer:list.searchInput.placeholder") }
          />
        </div>
        { this.renderSortToolbar() }
        <div
          className="body"
          ref={ (ref) => { this.listBody = ref } }
          onScroll={ this.onScroll.bind(this) }
        >
          <ul
            className="list"
            ref={ (ref) => { this.listElem = ref } }
          >
            { this.renderBulkSectionHeadline() }
            { this.renderBulkEdit() }
            { this.renderPlaceholder() }
            { this.renderMediaPlayerItems() }
            { this.renderNextPage() }
          </ul>
        </div>
        { this.renderBackToTop() }
      </div>
    )
  }
}

MediaPlayerList.propTypes = {}

const mapStateToProps = (state, props) => selector(state)

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveSort,
      fetchSort,
      fetchItems,
      fetchStatus,
      saveFilter,
      fetchFilter,
      nextPage
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaPlayerList)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/media-player/list.jsx